import { render, staticRenderFns } from "./TipoTicketEdit.vue?vue&type=template&id=17741f9a&scoped=true"
import script from "./TipoTicketEdit.vue?vue&type=script&lang=js"
export * from "./TipoTicketEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17741f9a",
  null
  
)

export default component.exports